var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "video-replay-popup" }, [
    _vm._m(0),
    _vm.videoUrl
      ? _c("div", { staticClass: "video-container" }, [
          _c("video", {
            staticClass: "replay-video",
            attrs: { id: "replay-video", controls: "", src: _vm.videoUrl },
          }),
        ])
      : _c("div", { staticClass: "video-container error" }, [
          _c("p", [_vm._v("No video URL provided")]),
        ]),
    _c("div", { staticClass: "match-info" }, [
      _c("div", { staticClass: "info-row" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Arena:")]),
        _c("span", { staticClass: "value text-uppercase" }, [
          _vm._v(_vm._s(_vm.arenaCode)),
        ]),
      ]),
      _c("div", { staticClass: "info-row" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Match:")]),
        _c("span", { staticClass: "value" }, [_vm._v(_vm._s(_vm.matchCode))]),
      ]),
      _c("div", { staticClass: "info-row" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Fight:")]),
        _c("span", { staticClass: "value" }, [_vm._v(_vm._s(_vm.fightNumber))]),
      ]),
      _c("div", { staticClass: "info-row" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Time:")]),
        _c("span", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.formattedTime)),
        ]),
      ]),
      _c("div", { staticClass: "info-row" }, [
        _c("span", { staticClass: "label" }, [_vm._v("Result:")]),
        _c(
          "span",
          { staticClass: "value text-uppercase", class: _vm.resultClass },
          [_vm._v(_vm._s(_vm.result))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "video-replay-header" }, [
      _c("img", {
        staticClass: "header-logo",
        attrs: {
          src: require("@/assets/images/logos/default.webp"),
          alt: "Logo",
        },
      }),
      _c("h2", [_vm._v("Video Replay")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }